import React from "react";
import StudyGroupField from "server/components/Fields/StudyGroupField";
import { Grid } from "@mui/material";
import { Button, SaveButton, SimpleForm, useNotify, useRefresh } from "react-admin";
import CloseIcon from "@mui/icons-material/Close";
import useConflictErrorModal from "server/components/Modals/useConflictErrorModal";
import dataProvider from "server/dataProvider";
import { graduationRequests } from "api/graduationApi";
import { useNotifyError } from "utils/useNotifyError";

const StudyGroupsEditForm = ({ setIsStudyGroupsEditing, record }) => {
  const { handleConflictError, ConflictErrorDialog } = useConflictErrorModal();
  const notifyError = useNotifyError();
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSubmit = async data => {
    const payload = { studyGroups: data.studyGroups };
    try {
      await dataProvider.customRequest(graduationRequests.updateStateExamStudyGroups(record?.id), payload, "PUT");
      refresh();
      notify("Записът е редактиран", { type: "success" });
      setIsStudyGroupsEditing(false);
    } catch (err) {
      notifyError(err);
      handleConflictError(err);
    }
  };

  return (
    <Grid
      item
      xs={12}
      md={4}
    >
      <SimpleForm
        toolbar={false}
        sx={{ pt: 0, pl: 0 }}
        onSubmit={handleSubmit}
      >
        <StudyGroupField label=" Пример за въвеждане на Учебни групи: 1-5, 8, 11-13, 15" />
        <Grid sx={{ display: "flex", gap: 3, mt: 3 }}>
          <Button
            variant="outlined"
            startIcon={<CloseIcon />}
            color="error"
            size="small"
            label="Откажи"
            onClick={() => setIsStudyGroupsEditing(false)}
          />
          <SaveButton
            label="Запази"
            size="small"
          />
          <ConflictErrorDialog />
        </Grid>
      </SimpleForm>
    </Grid>
  );
};

export default StudyGroupsEditForm;
